import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M9 16L12 19L15 16L14.293 15.293L12.5 17.086V5H11.5V17.086L9.707 15.293L9 16Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ThinLong02Down"
);
